import React from 'react'

import type { MenuContentBlock } from '@library/api-menu-experience'

import { CategoryGridContentBlockWrapper } from './ContentBlocks/CategoryGridContentBlockWrapper'
import { SimpleHeaderContentBlockWrapper } from './ContentBlocks/SimpleHeaderContentBlockWrapper'

const renderContentBlock = (contentBlock: MenuContentBlock) => {
  switch (contentBlock.type) {
    case 'category-grid':
      return <CategoryGridContentBlockWrapper contentBlock={contentBlock} />
    case 'simple-header':
      return <SimpleHeaderContentBlockWrapper contentBlock={contentBlock} />
    case 'recipe-grid':
      return null
    case 'campaign-banner':
      return null
    case 'compact-campaign-banner':
      return null
    case 'category-branding':
      return null
    case 'wave-link-header':
      return null
    case 'gradient-info-header':
      return null
    default:
      return null
  }
}

export const renderContentBlocks = (contentBlocks: MenuContentBlock[]) =>
  contentBlocks.map((contentBlock, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={`${contentBlock.type}-${index}`}>
      {renderContentBlock(contentBlock)}
    </React.Fragment>
  ))
